(function () {
  'use strict';

  var CONTEXT = window.SINCERE_GA4_CONTEXT || {};
  var DEBUG = false;
  var CART_SNAPSHOT_KEY = 'sincere_ga4_cart_snapshot_v1';
  var INTENT_KEY = 'sincere_ga4_add_intent_v1';
  var CHECKOUT_LOCK_KEY = 'sincere_ga4_begin_checkout_lock_v1';
  var lastCart = readSnapshot();
  var queuedCartSync = null;
  var viewedProductVariant = null;
  var viewedCartFingerprints = {};
  var pushedFingerprints = {};

  window.dataLayer = window.dataLayer || [];

  function log() {
    if (!DEBUG || !window.console) return;
    console.log.apply(console, ['[GA4 Theme]'].concat([].slice.call(arguments)));
  }

  function toNumber(value) {
    var n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  function now() {
    return Date.now();
  }

  function normalizeText(v) {
    return (v || '').toString().trim();
  }

  function makeFingerprint(eventName, payload) {
    return eventName + '|' + JSON.stringify(payload || {});
  }

  function shouldSkipDuplicate(eventName, payload, ttlMs) {
    var key = makeFingerprint(eventName, payload);
    var ts = pushedFingerprints[key];
    var nowTs = now();
    if (ts && nowTs - ts < (ttlMs || 1500)) return true;
    pushedFingerprints[key] = nowTs;
    return false;
  }

  function pushEvent(eventName, ecommerce, options) {
    var payload = {
      event: eventName,
      ecommerce: ecommerce || {}
    };
    var ttlMs = options && options.ttlMs ? options.ttlMs : 1500;
    if (shouldSkipDuplicate(eventName, payload.ecommerce, ttlMs)) {
      return;
    }
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
    log('push', payload);
  }

  function itemFromVariantInfo(variantId, name, brand, category, variantName, price, quantity) {
    return {
      item_id: variantId || null,
      item_name: normalizeText(name),
      item_brand: normalizeText(brand),
      item_category: normalizeText(category),
      item_variant: normalizeText(variantName),
      price: toNumber(price),
      quantity: Math.max(1, parseInt(quantity || 1, 10))
    };
  }

  function itemFromCartLine(lineItem, quantityOverride) {
    return itemFromVariantInfo(
      lineItem.variant_id || lineItem.id,
      lineItem.product_title || lineItem.title,
      lineItem.vendor,
      lineItem.product_type,
      lineItem.variant_title,
      toNumber(lineItem.final_price) / 100,
      quantityOverride != null ? quantityOverride : lineItem.quantity
    );
  }

  function mapCartItems(cart) {
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.map(function (line) {
      return itemFromCartLine(line);
    });
  }

  function snapshotFromCart(cart) {
    var map = {};
    var byVariant = {};
    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    items.forEach(function (line) {
      var lineKey = line.key || (line.variant_id + ':' + line.quantity);
      map[lineKey] = toNumber(line.quantity);
      if (line.variant_id) {
        byVariant[String(line.variant_id)] = {
          quantity: toNumber(line.quantity),
          line: line
        };
      }
    });
    return {
      token: cart && cart.token ? cart.token : '',
      item_count: toNumber(cart && cart.item_count),
      total_price: toNumber(cart && cart.total_price),
      map: map,
      byVariant: byVariant,
      raw: cart || {}
    };
  }

  function writeSnapshot(snapshot) {
    try {
      localStorage.setItem(CART_SNAPSHOT_KEY, JSON.stringify(snapshot || null));
    } catch (e) {}
  }

  function readSnapshot() {
    try {
      var raw = localStorage.getItem(CART_SNAPSHOT_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setAddIntent(variantId) {
    if (!variantId) return;
    try {
      localStorage.setItem(
        INTENT_KEY,
        JSON.stringify({ variantId: String(variantId), ts: now() })
      );
    } catch (e) {}
  }

  function readAddIntent() {
    try {
      var raw = localStorage.getItem(INTENT_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function clearAddIntent() {
    try {
      localStorage.removeItem(INTENT_KEY);
    } catch (e) {}
  }

  function fetchCart() {
    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart.js failed');
      return r.json();
    });
  }

  function syncCartSnapshot() {
    if (queuedCartSync) return queuedCartSync;
    queuedCartSync = fetchCart()
      .then(function (cart) {
        lastCart = snapshotFromCart(cart);
        writeSnapshot(lastCart);
        return lastCart;
      })
      .catch(function () {
        return lastCart;
      })
      .finally(function () {
        queuedCartSync = null;
      });
    return queuedCartSync;
  }

  function getCurrency() {
    return normalizeText(CONTEXT.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '');
  }

  function buildProductItemFromContext(variantId) {
    var product = CONTEXT.product || {};
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var selected = null;
    if (variantId) {
      selected = variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
    }
    if (!selected) {
      selected = variants.find(function (v) {
        return String(v.id) === String(product.selected_variant_id);
      }) || variants[0];
    }
    if (!selected) return null;
    return itemFromVariantInfo(
      selected.id,
      product.title,
      product.vendor,
      product.type,
      selected.title,
      selected.price,
      1
    );
  }

  function pushViewItem(variantId) {
    var item = buildProductItemFromContext(variantId);
    if (!item) return;
    if (String(viewedProductVariant) === String(item.item_id)) return;
    viewedProductVariant = item.item_id;
    pushEvent('view_item', {
      currency: getCurrency(),
      value: toNumber(item.price),
      items: [item]
    }, { ttlMs: 400 });
  }

  function initViewItem() {
    if (!CONTEXT.product) return;
    pushViewItem(CONTEXT.product.selected_variant_id);
    document.addEventListener('action:update:VariantSelectorChangeBasedOnSelector', function (e) {
      if (!e || !e.detail || !e.detail.productVariant) return;
      pushViewItem(e.detail.productVariant);
    });
  }

  function getItemFromCard(card) {
    if (!card) return null;
    var itemId = card.getAttribute('data-ga4-item-id');
    var price = card.getAttribute('data-ga4-price');
    return itemFromVariantInfo(
      itemId,
      card.getAttribute('data-ga4-item-name'),
      card.getAttribute('data-ga4-brand'),
      card.getAttribute('data-ga4-category'),
      card.getAttribute('data-ga4-variant'),
      toNumber(price),
      1
    );
  }

  function getListMeta(card) {
    var container = card && card.closest('[data-ga4-list-name]');
    var listName = (card && card.getAttribute('data-ga4-list-name')) || (container && container.getAttribute('data-ga4-list-name')) || (CONTEXT.collection && CONTEXT.collection.name) || 'Product List';
    var listId = (card && card.getAttribute('data-ga4-list-id')) || (container && container.getAttribute('data-ga4-list-id')) || (CONTEXT.collection && CONTEXT.collection.id) || 'product_list';
    var index = toNumber((card && card.getAttribute('data-ga4-index')) || 0);
    return { listName: listName, listId: listId, index: index };
  }

  function initListTracking() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-ga4-item-id]'));
    if (!cards.length) return;

    var listItems = cards.map(function (card) {
      var item = getItemFromCard(card);
      var meta = getListMeta(card);
      if (!item) return null;
      item.item_list_id = meta.listId;
      item.item_list_name = meta.listName;
      item.index = meta.index || undefined;
      return item;
    }).filter(Boolean);

    if (listItems.length) {
      var first = listItems[0];
      pushEvent('view_item_list', {
        item_list_id: first.item_list_id,
        item_list_name: first.item_list_name,
        items: listItems
      }, { ttlMs: 1500 });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('a,button');
      if (!trigger) return;
      var card = trigger.closest('[data-ga4-item-id]');
      if (!card) return;
      var item = getItemFromCard(card);
      if (!item) return;
      var meta = getListMeta(card);
      item.item_list_id = meta.listId;
      item.item_list_name = meta.listName;
      item.index = meta.index || undefined;
      pushEvent('select_item', {
        item_list_id: meta.listId,
        item_list_name: meta.listName,
        items: [item]
      }, { ttlMs: 250 });
    }, true);
  }

  function computeCartDiff(previous, current) {
    var prevMap = previous && previous.map ? previous.map : {};
    var prevVariantMap = previous && previous.byVariant ? previous.byVariant : {};
    var currMap = current && current.map ? current.map : {};
    var currVariantMap = current && current.byVariant ? current.byVariant : {};
    var added = [];
    var removed = [];

    Object.keys(currMap).forEach(function (lineKey) {
      var currQty = toNumber(currMap[lineKey]);
      var prevQty = toNumber(prevMap[lineKey]);
      if (currQty > prevQty) {
        var line = current.raw.items.find(function (i) { return i.key === lineKey; });
        if (line) added.push({ line: line, quantity: currQty - prevQty });
      }
    });

    Object.keys(prevMap).forEach(function (lineKey) {
      var prevQty = toNumber(prevMap[lineKey]);
      var currQty = toNumber(currMap[lineKey]);
      if (currQty < prevQty) {
        var line = (previous.raw.items || []).find(function (i) { return i.key === lineKey; });
        if (line) removed.push({ line: line, quantity: prevQty - currQty });
      }
    });

    return { added: added, removed: removed, prevVariantMap: prevVariantMap, currVariantMap: currVariantMap };
  }

  function sourceLooksLikeAdd(sourceElement, detail) {
    var tag = sourceElement && sourceElement.tagName ? sourceElement.tagName.toUpperCase() : '';
    if (tag === 'PRODUCT-FORM' || tag === 'PRODUCT-CARD') return true;
    if (detail && detail.productVariant) return true;
    var intent = readAddIntent();
    return !!(intent && now() - toNumber(intent.ts) < 5000);
  }

  function handleCartChange(sourceElement, detail) {
    var prevSnapshot = lastCart || readSnapshot();
    syncCartSnapshot().then(function (currSnapshot) {
      if (!currSnapshot) return;
      var diff = computeCartDiff(prevSnapshot, currSnapshot);
      var addLike = sourceLooksLikeAdd(sourceElement, detail);

      if (addLike && diff.added.length) {
        diff.added.forEach(function (entry) {
          var item = itemFromCartLine(entry.line, entry.quantity);
          pushEvent('add_to_cart', {
            currency: getCurrency(),
            value: toNumber(item.price) * toNumber(item.quantity),
            items: [item]
          }, { ttlMs: 800 });
        });
      }

      var sourceTag = sourceElement && sourceElement.tagName ? sourceElement.tagName.toUpperCase() : '';
      var removeFromCartContext = sourceTag === 'DRAWER-CART' || sourceTag === 'CART-PAGE';
      if (removeFromCartContext && diff.removed.length) {
        diff.removed.forEach(function (entry) {
          var item = itemFromCartLine(entry.line, entry.quantity);
          pushEvent('remove_from_cart', {
            currency: getCurrency(),
            value: toNumber(item.price) * toNumber(item.quantity),
            items: [item]
          }, { ttlMs: 800 });
        });
      }

      clearAddIntent();
    });
  }

  function initAddToCartTracking() {
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('button[type="submit"], button[data-variant-id], .sq-atc-btn');
      if (!trigger) return;
      var form = trigger.closest('form');
      var variantInput = form && form.querySelector('input[name="id"]');
      var variantId = (variantInput && variantInput.value) || trigger.getAttribute('data-variant-id');
      if (variantId) setAddIntent(variantId);
    }, true);

    document.addEventListener('action:cart:updateCart', function (e) {
      handleCartChange(e.target, e.detail || {});
    });
    document.addEventListener('action:cart:updateCartandShowCart', function () {
      handleCartChange(document.body, {});
    });
  }

  function cartFingerprint(cart) {
    var token = normalizeText(cart && cart.token);
    var count = toNumber(cart && cart.item_count);
    var total = toNumber(cart && cart.total_price);
    return token + '|' + count + '|' + total;
  }

  function pushViewCartFromCart(cart, source) {
    if (!cart) return;
    var fp = cartFingerprint(cart);
    if (viewedCartFingerprints[fp] && now() - viewedCartFingerprints[fp] < 3000) return;
    viewedCartFingerprints[fp] = now();
    pushEvent('view_cart', {
      currency: getCurrency(),
      value: toNumber(cart.total_price) / 100,
      items: mapCartItems(cart)
    }, { ttlMs: 400 });
    log('view_cart source:', source);
  }

  function initViewCartTracking() {
    if (CONTEXT.page_type === 'cart' && CONTEXT.cart) {
      var cartItems = Array.isArray(CONTEXT.cart.items) ? CONTEXT.cart.items : [];
      var cartItemCount = cartItems.reduce(function (acc, item) {
        return acc + toNumber(item.quantity);
      }, 0);
      var cartLike = {
        token: CONTEXT.cart.token,
        item_count: cartItemCount,
        total_price: toNumber(CONTEXT.cart.value) * 100,
        items: cartItems.map(function (item) {
          return {
            variant_id: item.item_id,
            product_title: item.item_name,
            vendor: item.item_brand,
            product_type: item.item_category,
            variant_title: item.item_variant,
            final_price: toNumber(item.price) * 100,
            quantity: item.quantity
          };
        })
      };
      pushViewCartFromCart(cartLike, 'cart_page');
    }

    document.addEventListener('action:showDrawer', function (e) {
      if (!e || !e.detail || e.detail.drawerType !== 'cart-drawer') return;
      fetchCart().then(function (cart) {
        pushViewCartFromCart(cart, 'cart_drawer');
      }).catch(function () {});
    });
  }

  function checkoutLockActive() {
    try {
      var raw = localStorage.getItem(CHECKOUT_LOCK_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      return now() - toNumber(data.ts) < 4000;
    } catch (e) {
      return false;
    }
  }

  function setCheckoutLock() {
    try {
      localStorage.setItem(CHECKOUT_LOCK_KEY, JSON.stringify({ ts: now() }));
    } catch (e) {}
  }

  function pushBeginCheckout() {
    if (checkoutLockActive()) return;
    setCheckoutLock();
    fetchCart().then(function (cart) {
      pushEvent('begin_checkout', {
        currency: getCurrency(),
        value: toNumber(cart.total_price) / 100,
        items: mapCartItems(cart)
      }, { ttlMs: 3000 });
    }).catch(function () {});
  }

  function initBeginCheckoutTracking() {
    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('button[name="checkout"], a[href*="/checkout"], #sep-cta-btn');
      if (!trigger) return;
      pushBeginCheckout();
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var checkoutBtn = form.querySelector('button[name="checkout"]');
      if (checkoutBtn) {
        pushBeginCheckout();
      }
    }, true);
  }

  function initPurchaseNote() {
    window.SINCERE_GA4_PURCHASE_FROM_THEME_SUPPORTED = false;
  }

  initViewItem();
  initListTracking();
  initAddToCartTracking();
  initViewCartTracking();
  initBeginCheckoutTracking();
  initPurchaseNote();
  syncCartSnapshot();
})();
